// extracted by mini-css-extract-plugin
export default {"experience":"style_experience__TUCWW","achievement":"style_achievement__24JyK","circle":"style_circle__wS2ul"};